module.exports = __webpack_public_path__ + "img/CertificateOfHonor03.73706c89.png";